import { SalleComponent } from './salle/salle.component';
import { CultureComponent } from './culture/culture.component';
import { RecetteComponent } from './recette/recette.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TacheComponent } from './tache/tache.component';
import { ParamUtilisateurComponent } from './parametre/param-utilisateur/param-utilisateur.component';
import { ParametreComponent } from './parametre/parametre.component';
import { ParamTacheComponent } from './parametre/param-tache/param-tache.component';

const routes: Routes = [{
  path: '',
  component: PagesComponent,
  children: [
    {
      path: 'dashboard',
      component: DashboardComponent,
    },
    {
      path: 'recette',
      component: RecetteComponent,
    },
    {
      path: 'taches',
      component: TacheComponent,
    },
    {
      path: 'salle',
      children: [
        {
          path: 'culture',
          component: SalleComponent,
        },
        {
          path: 'germination',
          component: SalleComponent,
        },
        {
          path: 'recolte',
          component: SalleComponent,
        },
        {
          path: 'lavage',
          component: SalleComponent,
        },
      ],
    },

    {
      path: 'parametre',
      children: [
        {
          path: 'utilisateurs',
          component: ParamUtilisateurComponent,
        },
        {
          path: 'tache',
          component: ParamTacheComponent,
        },
      ],
    },
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
